import React from 'react';
import Rachat from '../Rachat';
const RachatDeCreditPage = () => {
    return (
        <div>
            <Rachat/>
        </div>
    );
};

export default RachatDeCreditPage;